import { Component, OnInit, ViewContainerRef, ViewChild, ComponentFactoryResolver, ChangeDetectorRef, HostListener, AfterContentInit, ChangeDetectionStrategy, ComponentFactory, ComponentRef, EventEmitter, inject, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentLocator } from '../component-locator';
import { ViewModelLocator } from '../../view-models/view-model-locator';
import { MasterDetailOrchestratorViewModel } from '../../view-models/master-detail-orchestrator-view-model';
import { ToolBarViewModelInterface } from '../../view-models/tool-bar-view-model.interface';
import { ToastMessageService } from '../layout/toast-message/toast-message.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SnapShotAPIClient } from '../../api-clients/snap-shot-api-client';
import { CurrentRouteService, RouteChangeParams, RoutingService } from '../../routing';
import { LogService, OnlineService, UpdateService, UpdateServiceData, UpdateServiceStatusType, UUIDHelper } from '@nts/std/utility';
import { TokenService } from '../../auth/token.service';
import { BaseContainerComponent } from '../layout/base-container/base-container.component';
import { ServiceResponse } from '../../responses/service-response';
import { ComponentErrorInterface } from '../errors/component-error.interface';
import { ForbiddenComponent } from '../errors/forbidden/forbidden.component';
import { SpoolProcess } from '../../domain-models/spool/spool-process';
import { HttpParams } from '@angular/common/http';
import { filter, take } from 'rxjs/operators';
import { BehaviorSubject, firstValueFrom, Subscription } from 'rxjs';
import { MessageResourceManager } from '../../resources/message-resource-manager';
import { EnvironmentConfiguration } from '@nts/std/environments';
import { UIStarter } from '../../starter/ui-starter';
import { PresentationCache } from '../../cache/presentation-cache';
import { AsyncPipe, Location, NgClass, NgIf } from '@angular/common';
import { OperationIdentity } from '../../domain-models/report/operation.identity';
import { ReportInfoDto } from '../../domain-models/report/report-info.dto';
import { AuthService } from '../../auth/auth.service';
import { DynamicPresentationComponent } from '../dynamic-presentation/dynamic-presentation.component';
import { LayoutDefinitionIdentity } from '../../domain-models/layout/layout-definition.identity';
import { BaseAggregateComponent } from '../base-aggregate/base-aggregate.component';
import { ClassConstructor } from '@nts/std/serialization';
import { BaseLayoutDataDto } from '../../domain-models/layout/base-layout-data.dto';
import { animate, sequence, state, style, transition, trigger } from '@angular/animations';
import { LongOpOrchestratorViewModel } from '../../view-models/long-op/long-op-orchestrator-view-model';
import { OrchestratorViewModel } from '../../view-models/orchestrator-view-model';
import { AvailableLayoutsInfoDto } from '../../domain-models/layout/available-layouts-info.dto';
import { TelemetryService } from '@nts/std/telemetry';
import { LoaderComponent } from '../shared/loader/loader.component';
import { PageHeaderComponent } from '../layout/page-header/page-header.component';
import { TextButtonComponent } from '../shared/buttons/text-button/text-button.component';
import { NavigationPanelComponent } from '../navigation-panel/navigation-panel.component';
import { ToolBarComponent } from '../layout/tool-bar/tool-bar.component';
import { ValidationComponent } from '../layout/validation/validation.component';
import { NotificationComponent } from '../layout/notification/notification.component';
import { WingContainerComponent } from '../wing-container/wing-container.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { MenuItem } from 'primeng/api';
import { MessageCodes } from '../../resources/message-codes';
import { cloneDeep } from 'lodash-es';
import { MessageType, MsgClearMode, ToastMessageType, ViewModelStates } from '@nts/std/types';
import { VersionEvent } from '@angular/service-worker';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToolbarComponentRegistry } from '../../../../components/helpers/toolbar-component-registry';
import { STANDARD_LAYOUT_CODE } from '../../view-models/core-orchestrator-view-model';
import { isConfigurableWingViewModel } from '../../view-models/wing/is-configurable-wing-view-model';
import { BaseError } from '@nts/std/messages';

import type { WingUiStateChangedEvent, ConfigurableWingViewModelInterface, ActionInProgressInterface, BaseErrorInterface, GenericServiceResponseInterface, LayoutDefinitionIdentityInterface, MasterDetailOrchestratorViewModelInterface, MasterViewModelInterface, MetaDataResponseInterface, OrchestratorViewModelInterface, RelatedRootViewModelInterface, ServiceResponseInterface, SnapShotListViewModelInterface, StandardComponentAwareInterface, StatusMessageInterface, ViewComponentInterface, ViewModelInterface } from '@nts/std/interfaces';
import type { LongOpOrchestratorViewModelInterface } from '@nts/std/interfaces';
import type { ToolBarComponentInterface } from '@nts/std/interfaces';

@UntilDestroy()
@Component({
  selector: 'nts-model-container',
  templateUrl: './model-container.component.html',
  styleUrls: ['./model-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('sideBarLeftOpenClose', [
      state('open', style({
        opacity: 1,
        display: 'flex',
        flexBasis: '280px',
      })),
      state('fullScreen', style({
        opacity: 1,
        display: 'flex',
        flexBasis: '100%',
      })),
      state('closed', style({
        opacity: 0,
        display: 'none',
        flexBasis: '0px',
      })),

      transition('open => closed', [
        sequence([
          animate('0.2s', style({
            opacity: '0',
            flexBasis: '280px'
          })),
          style({ display: 'none' }),
          animate('0.2s ease', style({
            flexBasis: '0'
          })),
        ])
      ]),
      transition('closed => open', [
        style({ display: 'flex' }),
        animate('0.2s 0.2s ease', style({
          flexBasis: '280px',
          opacity: '0',
        })),
        animate('0.2s', style({
          opacity: '1'
        })),
      ]),
    ]),
    trigger('sideBarLeftToggleVisibility', [
      state('visible', style({
        left: '9px',
        opacity: '1'
      })),
      state('hidden', style({
        left: '-40px',
        opacity: '0'
      })),
      transition('hidden => visible', [
        sequence([
          animate('0.2s 0.4s ease')
        ])
      ]),
      transition('visible => hidden', [
        sequence([
          animate('0.2s ease')
        ])
      ]),
    ])
  ],
  standalone: true,
  imports: [
    LoaderComponent,
    NgClass,
    PageHeaderComponent,
    NgIf,
    TextButtonComponent,
    AsyncPipe,
    NavigationPanelComponent,
    ValidationComponent,
    NotificationComponent,
    WingContainerComponent,
    SvgIconComponent,
  ]
})
export class ModelContainerComponent<TOrchestratorViewModel extends LongOpOrchestratorViewModelInterface | OrchestratorViewModelInterface = LongOpOrchestratorViewModelInterface | OrchestratorViewModelInterface> extends BaseContainerComponent implements OnInit, AfterContentInit, StandardComponentAwareInterface {

  @ViewChild('documentPlaceHolder', { read: ViewContainerRef, static: true }) documentPlaceHolder: ViewContainerRef;
  @ViewChild('toolbarContainer', { read: ViewContainerRef }) toolbarContainer!: ViewContainerRef;

  loaderText: string = '';
  loaderAnimation: boolean = false;
  viewModelLoaded: boolean = false;
  updateStatus: UpdateServiceData = { event: null, status: UpdateServiceStatusType.NoUpdateAvailable };
  moreOptionsMenuItemList$: BehaviorSubject<MenuItem[]> = new BehaviorSubject<MenuItem[]>([]);
  mobileMenuItemList$: BehaviorSubject<MenuItem[]> = new BehaviorSubject<MenuItem[]>([]);
  wingAnimationsEnabled = false;

  currentStandardComponentInstanceChanged = new EventEmitter<void>();
  currentStandardComponentType: ClassConstructor<BaseAggregateComponent<any>> = null;
  currentStandardComponentInstance: ViewComponentInterface<ViewModelInterface> = null;

  protected internalOrchestratorViewModel!: TOrchestratorViewModel;

  private toolbarComponentRef?: ComponentRef<ToolBarComponentInterface>;
  private _domainModelName: string = '';
  private _hasExternalReturn: boolean = false;
  private _hasHistoryBackButton: boolean = false;
  private _isRelated: boolean = false;
  private _currentLayout: string | null = null;
  private _isMasterDetail: boolean = false;
  private _isLongOp: boolean = false;
  private _isCrud: boolean = false;
  private _hasSnapShotFeature: boolean = false;
  private injector: Injector = inject(Injector);
  private wingUiStateSubscription?: Subscription;
  private toolbarRegistry = inject(ToolbarComponentRegistry);

  get configurableWingViewModel(): ConfigurableWingViewModelInterface | null {
    const wingVm = this.orchestratorViewModel?.wingViewModel;
    return wingVm && isConfigurableWingViewModel(wingVm) ? wingVm : null;
  }

  get isWingCollapsed(): boolean {
    return this.orchestratorViewModel?.wingViewModel?.panelState === 'closed';
  }

  get isWingOverlayMode(): boolean {
    return this.configurableWingViewModel?.effectiveDisplayMode() === 'overlay';
  }

  get isWingPushMode(): boolean {
    return this.configurableWingViewModel?.effectiveDisplayMode() === 'push';
  }

  get isWingDockBesideToolbar(): boolean {
    return this.configurableWingViewModel?.dockMode() === 'besideToolbar';
  }

  get isWingModal(): boolean {
    return this.configurableWingViewModel?.isModal() ?? false;
  }

  get showWingModalOverlay(): boolean {
    return this.isWingModal && !this.isWingCollapsed;
  }

  get wingWidth(): string {
    return this.configurableWingViewModel?.effectiveWidth() ?? '435px';
  }

  get showWingToggle(): boolean {
    const showToggle = this.configurableWingViewModel?.showToggle() ?? true;
    return showToggle === 'alternate' ? !this.isWingCollapsed : showToggle;
  }

  get wingToggleIconKey(): string {
    return this.orchestratorViewModel?.wingViewModel?.panelState === 'closed'
      ? 'arrow-back'
      : 'arrow-forward';
  }

  get orchestratorViewModel(): TOrchestratorViewModel {
    return this.internalOrchestratorViewModel;
  }

  get masterViewModel(): MasterViewModelInterface | null {
    if (this.isMasterDetail) {
      const orchestratorViewModel: MasterDetailOrchestratorViewModelInterface = this.internalOrchestratorViewModel as MasterDetailOrchestratorViewModelInterface;
      return (orchestratorViewModel &&
        orchestratorViewModel.masterViewModel) ? orchestratorViewModel.masterViewModel : null;
    }
    return null;
  }

  get snapShotListViewModel(): SnapShotListViewModelInterface | null {
    if (this._hasSnapShotFeature) {
      const orchestratorViewModel: OrchestratorViewModelInterface = this.internalOrchestratorViewModel as OrchestratorViewModelInterface;
      return orchestratorViewModel && orchestratorViewModel.snapShotListViewModel ? orchestratorViewModel.snapShotListViewModel : null;
    }
    return null;
  }

  get isMasterDetail() {
    return this._isMasterDetail;
  }

  get hasSnapShotFeature() {
    return this._hasSnapShotFeature;
  }

  constructor(
    protected override readonly routingService: RoutingService,
    protected override readonly activatedRoute: ActivatedRoute,
    protected override readonly tokenService: TokenService,
    protected override readonly toastMessageService: ToastMessageService,
    protected override readonly updateService: UpdateService,
    protected override readonly onlineService: OnlineService,
    protected override readonly authService: AuthService,
    protected override readonly telemetryService: TelemetryService,
    protected override readonly environmentConfiguration: EnvironmentConfiguration,
    protected override readonly cd: ChangeDetectorRef,
    protected override readonly componentFactoryResolver: ComponentFactoryResolver,
    protected override readonly currentRouteService: CurrentRouteService,
    protected readonly router: Router,
    protected readonly componentLocator: ComponentLocator,
    protected readonly location: Location,
  ) {
    super(
      routingService,
      activatedRoute,
      tokenService,
      toastMessageService,
      updateService,
      onlineService,
      authService,
      telemetryService,
      environmentConfiguration,
      cd,
      componentFactoryResolver,
      currentRouteService
    );

    this._domainModelName = this.router.url.split('/')[2].toLowerCase().split('?')[0];
    this.internalOrchestratorViewModel = this.getOrchestrator(this._domainModelName) as TOrchestratorViewModel;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.activatedRoute.parent.snapshot.queryParams['related'] != null) {
      this._isRelated = this.activatedRoute.parent.snapshot.queryParams['related'] === 'true';
    }
    if (this.activatedRoute.parent.snapshot.queryParams['layout'] != null) {
      this._currentLayout = this.activatedRoute.parent.snapshot.queryParams['layout'] as string;
    }
    if (this.activatedRoute.snapshot.queryParams['external-return'] != null) {
      this._hasExternalReturn = this.activatedRoute.snapshot.queryParams['external-return'] === 'true';
    }
    if (this.activatedRoute.snapshot.queryParams['history-back'] != null) {
      this._hasHistoryBackButton = this.activatedRoute.snapshot.queryParams['history-back'] === 'true';
    }

    this._isMasterDetail = this.internalOrchestratorViewModel instanceof MasterDetailOrchestratorViewModel;
    this._isLongOp = this.internalOrchestratorViewModel instanceof LongOpOrchestratorViewModel;
    this._isCrud = this.internalOrchestratorViewModel instanceof OrchestratorViewModel;

    if (!this.internalOrchestratorViewModel) { throw new Error('Missing orchestratorViewModel!'); }

    this.updateQueryParams();
    this.handleExternalReturnLogic();
    this.handleIsRelatedLogic();
    this.handleHasLayoutLogic();
    void this.handleHasHistoryBackButtonLogic();
    this.startSubscribers();

  }

  override async ngAfterViewInit(): Promise<void> {
    await super.ngAfterViewInit();
    this.bindWingViewportChanges();
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  async ngAfterContentInit() {
    this.documentPlaceHolder.clear();

    // Visualizzo il loader
    this.internalOrchestratorViewModel.eventDispatcher.onActionInProgress.next({
      inProgress: true,
      loaderText: MessageResourceManager.Current.getMessage('std_CaricamentoInProgress')
    });

    // Aggiungendo questa logica si aspetta l'eventuale redirect senza far vedere messaggi di errore
    if (!await this.handleTokenIdParam()) {
      this.internalOrchestratorViewModel.eventDispatcher.onActionInProgress.next({
        inProgress: true,
        loaderText: 'Cambio tenant in corso...'
      });
      return;
    }

    if (this.currentRouteService.isAuthenticatedRoute) {
      let error: BaseError;
      if (this.internalOrchestratorViewModel.getCustomEnterpriseDataError) {
        error = await this.internalOrchestratorViewModel.getCustomEnterpriseDataError();
      } else {
        error = await this.internalOrchestratorViewModel.authService.getEnterpriseDataError();
      }

      if (error) {
        return await this.renderErrorComponentFromErrors([error]);
      }
    }

    // Pre init ovm
    if (this.internalOrchestratorViewModel.preInit) {
      await this.internalOrchestratorViewModel.preInit();
    }

    // Composition e DI dinamica
    const viewModelType: any = this.internalOrchestratorViewModel.rootViewModelType;

    // Verifico se l'utente ha i permessi per avere lo snapshot
    if (this.internalOrchestratorViewModel.apiClient instanceof SnapShotAPIClient) {
      this.internalOrchestratorViewModel.canAccessToSnapShot().pipe(this.untilDestroyed(), take(1)).subscribe((res) => {
        this._hasSnapShotFeature = res;
        this.cd.detectChanges();
      });
    }

    // Verifico se l'utente ha i permessi per gestire il layout
    const canAccessToLayout: boolean = await firstValueFrom(this.internalOrchestratorViewModel.canAccessToLayout().pipe(this.untilDestroyed()));
    let availableLayoutsResponse: GenericServiceResponseInterface<AvailableLayoutsInfoDto>;

    if (canAccessToLayout) {
      // Inizializzo la logica per i layout della maschera
      availableLayoutsResponse = await this.internalOrchestratorViewModel.initLayoutsMetaData();
      if (availableLayoutsResponse.operationSuccedeed !== true) {
        this.toastMessageService.showToast({
          message: MessageResourceManager.Current.getMessage('Toast_Layout_Not_Available'),
          title: MessageResourceManager.Current.getMessage(MessageCodes.Warning),
          type: ToastMessageType.warn
        });
        this.currentStandardComponentType = this.componentLocator.getComponentType(viewModelType);
      } else {
        // Se ho un selezionato un template personalizzato
        if (this.internalOrchestratorViewModel.layoutMetaData) {
          this.currentStandardComponentType = DynamicPresentationComponent;
        } else {
          this.currentStandardComponentType = this.componentLocator.getComponentType(viewModelType);
        }
      }
    } else {
      this.currentStandardComponentType = this.componentLocator.getComponentType(viewModelType);
    }

    let layoutIdentity: LayoutDefinitionIdentityInterface = null;
    let metaDataResponse: MetaDataResponseInterface;

    // Se ho un selezionato un template personalizzato
    if (this.internalOrchestratorViewModel.layoutMetaData && availableLayoutsResponse?.operationSuccedeed === true) {

      // Imposto il layout identity del layout personalizzato
      layoutIdentity = this.internalOrchestratorViewModel.currentLayout.identity;

      // Utilizzo una getMetaData diversa che contiene le informazioni incrociate per i layout personalizzati
      metaDataResponse = await this.internalOrchestratorViewModel.initPresentationMetaData();
      metaDataResponse = await this.internalOrchestratorViewModel.postInitMetaData(metaDataResponse);
    } else {
      metaDataResponse = await this.internalOrchestratorViewModel.initMetaData();
      metaDataResponse = await this.internalOrchestratorViewModel.postInitMetaData(metaDataResponse);
      if (
        metaDataResponse.operationSuccedeed &&
        metaDataResponse.result &&

        // Se la chiamata di available layout non è andata a buon fine
        // vuol dire che ci sono problemi nel ms del layout quindi evito di chiedere lo user layout
        availableLayoutsResponse?.operationSuccedeed === true
      ) {
        await this.internalOrchestratorViewModel.initUserLayoutMetaData(metaDataResponse.result.rootFullName);
      }
    }

    if (metaDataResponse.operationSuccedeed && metaDataResponse.result) {

      // Inizializza l'orchestrator
      await this.internalOrchestratorViewModel.initialize();

      // TODO passare i metadati alla toolbar

      let jsonRouteParam: string = null;
      let isSingleAggregate: boolean = false;
      let isCompanySingleAggregate: boolean = false;
      const additionalErrors: BaseError[] = [];

      if (this._isLongOp) {

        const ovm: LongOpOrchestratorViewModelInterface = this.internalOrchestratorViewModel as LongOpOrchestratorViewModelInterface;
        jsonRouteParam = ovm.getJsonObjectFromRouteParam(this.activatedRoute.snapshot.params['identityToLookFor'] as string);
        ovm.jsonRouteParam = jsonRouteParam;

      } else if (this._isCrud) {
        const ovm: OrchestratorViewModelInterface = this.internalOrchestratorViewModel as OrchestratorViewModelInterface;
        try {
          jsonRouteParam = await ovm.getJsonIdentityFromIdentityParams(this.activatedRoute.snapshot.params['identityToLookFor'] as string);
        } catch (catchedError: any) {
          const errgetJsonIdentityFromIdentityParams: BaseError = new BaseError();
          const message: string = catchedError.message ?
            catchedError.message :
            catchedError.toString();

          errgetJsonIdentityFromIdentityParams.code = 'GenericError';
          errgetJsonIdentityFromIdentityParams.description = message;
          errgetJsonIdentityFromIdentityParams.stackTrace = catchedError.stack;
          LogService.log('Errore durante la getJsonIdentityFromIdentityParams', catchedError);
          additionalErrors.push(errgetJsonIdentityFromIdentityParams);
        }

        ovm.jsonRouteParam = jsonRouteParam;
        isSingleAggregate = ovm.isSingleAggregate();
        isCompanySingleAggregate = ovm.isCompanySingleAggregate();
      }

      // Verifico che non è stato cambiato l'enterprise data nel refresh precedente
      // Nel caso in cui provenissi da un altra ditta/azienda è necessario resettare lo stato dalla getByIdentity alla create per non confondere l'utente con i dati sottostanti
      // Se sono in una single aggregate visto che esiste solo la getByIDentity non devo considerare la logica della create al cambio ditta/azienda
      if (jsonRouteParam != null && (isSingleAggregate === true || isCompanySingleAggregate === true || this.authService.enterpriseDataChanged.value === false)) {
        await this.showRead(jsonRouteParam, layoutIdentity);
      } else {
        // Reset dello stato del cambio dell'enterprise
        this.authService.enterpriseDataChanged.next(false);
        await this.create(additionalErrors, layoutIdentity);
      }
    } else if (metaDataResponse.operationSuccedeed && !metaDataResponse.result) {
      const error: BaseError = new BaseError();
      error.code = 'InternalServerError';
      error.description = 'I metadati non sono stati trovati.';
      await this.renderErrorComponentFromErrors([error]);
    } else {
      return await this.renderErrorComponentFromResponse(metaDataResponse);
    }

    if (this.internalOrchestratorViewModel.actionInProgress) {
      this.internalOrchestratorViewModel.eventDispatcher.onActionInProgress.next(false);
    }

  }

  ngOnDestroy() {
    this.wingUiStateSubscription?.unsubscribe();
    this.internalOrchestratorViewModel?.onDestroy();
    this.currentStandardComponentInstance = null;
    this.documentPlaceHolder?.clear();
    this.internalOrchestratorViewModel = null;
  }

  async toggleWingPanel(): Promise<void> {
    if (this.configurableWingViewModel) {
      // Only enable animations if the toggle actually succeeds
      const success = await this.configurableWingViewModel.requestToggle('user');
      if (success) {
        this.wingAnimationsEnabled = true;
      }
      return;
    }

    // Legacy fallback - enable animations for state change
    this.wingAnimationsEnabled = true;
    const wingVm = this.orchestratorViewModel.wingViewModel;
    this.orchestratorViewModel.eventDispatcher.onWingCollapsed.next(wingVm.panelState === 'open');
  }

  async closeWingPanel(): Promise<void> {
    if (this.configurableWingViewModel) {
      const success = await this.configurableWingViewModel.requestClose('user');
      if (success) {
        this.wingAnimationsEnabled = true;
      }
      return;
    }

    const wingVm = this.orchestratorViewModel.wingViewModel;
    if (wingVm?.panelState === 'open') {
      this.wingAnimationsEnabled = true;
      this.orchestratorViewModel.eventDispatcher.onWingCollapsed.next(true);
    }
  }

  async handleHasHistoryBackButtonLogic() {
    if (this._hasHistoryBackButton) {
      await (this.internalOrchestratorViewModel.toolBarViewModel as ToolBarViewModelInterface).addHistoryBackButtonCommand(this.routingService);
    }
  }

  async createComponentInstance(
    currentComponentType: ClassConstructor<BaseAggregateComponent<any>>,
    layoutIdentity: LayoutDefinitionIdentityInterface = null
  ): Promise<ViewComponentInterface<ViewModelInterface>> {

    const componentRef = this.documentPlaceHolder.createComponent(currentComponentType);
    componentRef.instance.orchestratorViewModel = this.internalOrchestratorViewModel;
    componentRef.instance.layoutIdentity = layoutIdentity;
    return Promise.resolve(componentRef.instance);
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    if (this.unloadHandlerEnabled) {
      return this.internalOrchestratorViewModel.checkIfCanUnload();
    } else {
      return true;
    }
  }

  showUpdateNotificationToast(updateServiceData: UpdateServiceData) {
    switch (updateServiceData?.status) {
      case UpdateServiceStatusType.Updating:
        this.toastMessageService.showToast({
          title: 'Aggiornamento in corso',
          message: 'E\' disponibile una nuova versione. Sto scaricando la nuova versione...',
          type: ToastMessageType.info
        });
        break;
      case UpdateServiceStatusType.UpdatedNeedReload:
        this.toastMessageService.showUpdateConfirmToast({
          title: 'Aggiornamento disponibile',
          message: 'E\' disponibile una nuova versione. Clicca sul pulsante Aggiorna per aggiornare la pagina.',
          type: ToastMessageType.info
        }, 'Aggiorna', 'refresh').pipe(this.untilDestroyed()).subscribe(_ => window.location.reload());
        break;
      case UpdateServiceStatusType.UpdateError:
        this.toastMessageService.showUpdateConfirmToast({
          title: 'Aggiornamento fallito',
          message: 'L\'aggiornamento alla nuova versione non è andato a buon fine. Clicca sul pulsante Aggiorna per aggiornare la pagina e riprovare.',
          type: ToastMessageType.warn
        }, 'Aggiorna', 'refresh').pipe(this.untilDestroyed()).subscribe(_ => window.location.reload());
        break;
    }
  }

  handleHasLayoutLogic() {
    if (this._currentLayout) {
      this.internalOrchestratorViewModel.setStartingLayoutCode(this._currentLayout);
    }
  }

  handleIsRelatedLogic() {
    if (this._isRelated) {
      if (this.internalOrchestratorViewModel.setStartedAsRelatedClient !== undefined) {
        this.internalOrchestratorViewModel.setStartedAsRelatedClient();
      }
    }
  }

  handleExternalReturnLogic() {
    if (this._hasExternalReturn) {
      // se sono in un iframe non esiste windows openere ma windows parent
      const commandMessageAction: (jsonIdentity: string) => void = (jsonIdentity: string) => {
        this.tabMessagesSocket.send(jsonIdentity, MessageType.ExternalReturn);
      };

      this.internalOrchestratorViewModel.toolBarViewModel.addExternalReturnCommand('', commandMessageAction);
    }
  }

  handleToolBarSubscribers() {

    this.orchestratorViewModel.toolBarViewModel.loadedCompleted.pipe(
      untilDestroyed(this),
      filter((completed) => completed),
      take(1)
    ).subscribe(

      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async () => {
        this.moreOptionsMenuItemList$.next([
          ...await this.orchestratorViewModel.toolBarViewModel.getMoreOptionsMenuItems(this.toolbarComponentRef?.instance.moreOptionsMenu)
        ]);
        this.mobileMenuItemList$.next([
          ...await this.orchestratorViewModel.toolBarViewModel.getMobileMenuItems(this.toolbarComponentRef?.instance?.mobileMenu)
        ]);
      }
    );

    this.orchestratorViewModel.moreOptionsMenuItemUpdated.pipe(
      untilDestroyed(this)
    ).subscribe(
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async () => {
        this.moreOptionsMenuItemList$.next([
          ...await this.orchestratorViewModel.toolBarViewModel.getMoreOptionsMenuItems(this.toolbarComponentRef?.instance.moreOptionsMenu)
        ]);
      }
    );

    this.orchestratorViewModel.mobileMenuItemUpdated.pipe(
      untilDestroyed(this)
    ).subscribe(
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async () => {
        this.mobileMenuItemList$.next([
          ...await this.orchestratorViewModel.toolBarViewModel.getMobileMenuItems(this.toolbarComponentRef?.instance.mobileMenu)
        ]);
      }
    );
  }

  startSubscribers() {
    this.internalOrchestratorViewModel.eventDispatcher.onActionInProgress.pipe(untilDestroyed(this)).subscribe((actionInProgress: boolean | ActionInProgressInterface) => {
      if ((actionInProgress as ActionInProgressInterface).inProgress === true || (actionInProgress as ActionInProgressInterface).inProgress === false) {
        this.loaderText = (actionInProgress as ActionInProgressInterface).loaderText ?? '';
        this.loaderAnimation = (actionInProgress as ActionInProgressInterface).loaderAnimation ?? false;
      } else {
        this.loaderText = '';
        this.loaderAnimation = false;
      }
      this.cd.detectChanges();
    });

    this.internalOrchestratorViewModel.eventDispatcher.onNavigationPanelCollapsed.pipe(untilDestroyed(this)).subscribe(() => {
      this.cd.detectChanges();
    });

    this.internalOrchestratorViewModel.spoolProcessCompleted.pipe(untilDestroyed(this)).subscribe(
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async (process: SpoolProcess<any>) => {
        this.cd.detectChanges();
        await this.orchestratorViewModel.executeSpoolProcessCompleted(process);
      }
    );

    this.internalOrchestratorViewModel.openSpoolProcessRequested.pipe(untilDestroyed(this)).subscribe((operationIdentity: OperationIdentity) => {
      const routeChangeParams: RouteChangeParams = new RouteChangeParams();
      routeChangeParams.inBlank = true;
      routeChangeParams.addCredentials = true;
      routeChangeParams.rootModelFullName = 'SpoolService.OperationObjects.Models.Operation';
      routeChangeParams.routeParam = RoutingService.encodeObject(operationIdentity);
      this.routingService.routeChangeRequested.next(routeChangeParams);
    });

    this.internalOrchestratorViewModel.changeLayoutRequested.pipe(untilDestroyed(this)).subscribe((identity: LayoutDefinitionIdentity) => {

      // Verifico se ho già un query string
      const url: string = window.location.href;
      const splittedUrl: string[] = url.split('?');
      let calculatedUrl: string;
      if (splittedUrl[1] != null) { // Ho già un query string

        // https://armno.medium.com/creating-a-url-with-httpparams-in-angular-42783205f3f4
        const httpParams: HttpParams =
          new HttpParams({ fromString: splittedUrl[1] })  // Attenzione HttpParams è immutable
            .set('layout', identity.code);

        calculatedUrl = splittedUrl[0] + '?' + httpParams.toString();
      } else { // Non ho un query string
        calculatedUrl = url + '?layout=' + identity.code;
      }
      window.location.href = calculatedUrl;
    });

    this.internalOrchestratorViewModel.resetLayoutRequested.pipe(untilDestroyed(this)).subscribe(
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async (identity: LayoutDefinitionIdentity) => {
        const dto: BaseLayoutDataDto = new BaseLayoutDataDto();
        if (identity.code !== STANDARD_LAYOUT_CODE) {
          dto.layoutIdentity = identity;
        }
        this.internalOrchestratorViewModel.eventDispatcher.onActionInProgress.next(true);
        const response: GenericServiceResponseInterface<Boolean> = await firstValueFrom(this.internalOrchestratorViewModel.apiClient.clearUserLayoutMetaDataAsync(dto));
        if (response.operationSuccedeed === true) {
          window.location.reload();
        } else {
          this.internalOrchestratorViewModel.eventDispatcher.onActionInProgress.next(false);
          this.internalOrchestratorViewModel.showFromResponse(response, MsgClearMode.ClearOnlyTemporaryMessage);
        }
      }
    );

    this.internalOrchestratorViewModel.openLongOpReportRequested.pipe(untilDestroyed(this)).subscribe((reportInfoDto: ReportInfoDto) => {
      const routeChangeParams: RouteChangeParams = new RouteChangeParams();
      routeChangeParams.inBlank = true;
      routeChangeParams.fullUrl = reportInfoDto.uiFullAddress;
      routeChangeParams.addCredentials = true;
      routeChangeParams.rootModelFullName = reportInfoDto.ownerObjectFullName;
      this.routingService.routeChangeRequested.next(routeChangeParams);
    });
  }

  updateQueryParams() {
    this.internalOrchestratorViewModel.queryParams = this.activatedRoute.parent.snapshot.queryParams;
  }

  getOrchestrator(domainModelName: string): OrchestratorViewModelInterface {
    const orchestratorViewModelType = ViewModelLocator.getOrchestratorViewModelType(domainModelName);
    const ovm: OrchestratorViewModelInterface = inject(orchestratorViewModelType) as OrchestratorViewModelInterface;
    ovm.isDetached$ = this.isDetached$;
    ovm.initWingViewModel(this.injector);
    return ovm;
  }

  onToolBarReady() {
    this.handleToolBarSubscribers();
  }

  //la logica di verifica degli errori dell'enterprise viene già gestita nella ngAfterContentInit
  override async checkEnterpriseError(): Promise<boolean> {
    return Promise.resolve(false);
  }

  override async checkStatus(): Promise<StatusMessageInterface> {
    // se esiste una funzione custom sull'ovm verrà gestita da quella
    if (this.orchestratorViewModel.customHandlingCheckStatus) {
      return this.orchestratorViewModel.customHandlingCheckStatus();
    } else {
      return await this.orchestratorViewModel.checkStatus();
    }
  }

  override async renderErrorComponentFromErrors(errors: BaseError[]) {

    if (this.orchestratorViewModel.actionInProgress) {
      this.orchestratorViewModel.eventDispatcher.onActionInProgress.next(false);
    }

    this.documentPlaceHolder.clear();

    if (this.orchestratorViewModel.customRenderErrorComponentFromErrors) {
      if (errors?.length > 0) {
        errors[0].uuid = UUIDHelper.generateUUID();
      }
      await this.orchestratorViewModel.customRenderErrorComponentFromErrors(errors, this.documentPlaceHolder);
      if (errors?.length > 0) {
        this.track(errors[0]);
      }
    } else {

      let defaultError: BaseError = new BaseError();

      if (errors?.length > 0) {
        defaultError = cloneDeep(errors[0]);
      }

      defaultError.code = 'DefaultError';
      defaultError.description = defaultError.description?.length > 0 ? defaultError.description : 'Errore imprevisto';

      const computedErrors: BaseErrorInterface[] = errors?.length > 0 ? errors : [defaultError];

      const componentErrorMapping = this.getComponentErrorMapping();

      let componentError: ClassConstructor<ComponentErrorInterface>;

      const forbiddenErrors = computedErrors.filter((e) =>
        e.code === 'Unauthorized' || e.description === 'Forbidden'
      );

      if (forbiddenErrors?.length > 0) {
        componentError = ForbiddenComponent;
      } else {
        // se non esiste il componente per gestire il codice di errore
        if (componentErrorMapping[computedErrors[0].code] == null) {
          // aggiungo il codice di default
          computedErrors.unshift(defaultError);
        }
        componentError = componentErrorMapping[computedErrors[0].code];
      }

      const componentFactory: ComponentFactory<any> = this.componentFactoryResolver.resolveComponentFactory(componentError);
      const componentRef: ComponentRef<any> = this.documentPlaceHolder.createComponent(componentFactory);
      const componentInstance = componentRef.instance as ComponentErrorInterface;

      computedErrors[0].uuid = UUIDHelper.generateUUID();
      componentInstance.errors = computedErrors;
      this.track(computedErrors[0]);
    }

    this.cd.detectChanges();

    LogService.debug('renderErrorComponentFromErrors', errors);

  }

  override async handlePendingChanges(): Promise<boolean> {
    // se esiste una funzione custom sull'ovm verrà gestita da quella
    if (this.orchestratorViewModel.customHandlingPendingChanges) {
      return this.orchestratorViewModel.customHandlingPendingChanges();
    } else {
      return await this.orchestratorViewModel.checkIfPendingChanges();
    }
  }

  async create(
    additionalErrors: BaseErrorInterface[] = [],
    layoutIdentity: LayoutDefinitionIdentityInterface = null
  ) {
    if (this._isLongOp || this._isCrud) {
      const ovm: TOrchestratorViewModel = this.internalOrchestratorViewModel;
      const createResponse: ServiceResponseInterface = await ovm.create(false, additionalErrors);

      if (createResponse.operationSuccedeed === false && createResponse.errors.some((e) => e.responseInfo?.status != null && e.responseInfo?.status / 100 != 2)) {
        return await this.renderErrorComponentFromResponse(createResponse);
      } else {
        if (createResponse.operationSuccedeed === false && this.orchestratorViewModel.forceStopRenderPageAfterError === true) {
          return await this.renderErrorComponentFromResponse(createResponse);
        }

        await this.onViewModelLoaded(
          this.internalOrchestratorViewModel.rootViewModel,
          createResponse.errors?.length > 0
            ? createResponse.errors
            : undefined,
          layoutIdentity
        );
      }
    }
  }

  async renderErrorComponentFromResponse(result: ServiceResponseInterface): Promise<void> {
    if (this.orchestratorViewModel.actionInProgress) {
      this.orchestratorViewModel.eventDispatcher.onActionInProgress.next(false);
    }
    if (result.operationSuccedeed == false) {

      this.documentPlaceHolder.clear();

      if (this.orchestratorViewModel.customRenderErrorComponentFromResponse) {
        if (result.errors?.length > 0) {
          result.errors[0].uuid = UUIDHelper.generateUUID();
        }

        await this.orchestratorViewModel.customRenderErrorComponentFromResponse(result, this.documentPlaceHolder);
        if (result.errors?.length > 0) {
          this.track(result.errors[0]);
        }

      } else {

        let defaultError: BaseErrorInterface = new BaseError();

        if (result.errors?.length > 0) {
          defaultError = cloneDeep(result.errors[0]);
        }

        defaultError.code = 'DefaultError';
        defaultError.description = defaultError.description?.length > 0 ? defaultError.description : 'Errore imprevisto';

        const errors: BaseErrorInterface[] = result.errors?.length > 0 ? result.errors : [defaultError];


        const componentErrorMapping = this.getComponentErrorMapping();

        let componentError: ClassConstructor<ComponentErrorInterface>;

        const forbiddenErrors = errors.filter((e) =>
          e.code === MessageCodes.UnauthorizedHttpStatusCode || e.description === 'Forbidden'
        );

        if (forbiddenErrors?.length > 0) {
          componentError = ForbiddenComponent;
        } else {
          // se non esiste il componente per gestire il codice di errore
          if (componentErrorMapping[errors[0].code] == null) {
            // aggiungo il codice di default
            errors.unshift(defaultError);
          }
          componentError = componentErrorMapping[errors[0].code];
        }

        const componentFactory: ComponentFactory<any> = this.componentFactoryResolver.resolveComponentFactory(componentError);
        const componentRef: ComponentRef<any> = this.documentPlaceHolder.createComponent(componentFactory);
        const componentInstance = componentRef.instance as ComponentErrorInterface;

        errors[0].uuid = UUIDHelper.generateUUID();
        componentInstance.errors = errors;
        this.track(errors[0]);
      }

      this.cd.detectChanges();

      LogService.debug('renderErrorComponentFromResponse', result);

    }
  }

  protected override async handleUpdateNotification(evt: VersionEvent): Promise<void> {
    // Disable update toast notification in standard container
    // We use notification icon in toolbar
    switch (evt.type) {
      case 'VERSION_DETECTED':
        LogService.debug(`Downloading new app version: ${evt.version.hash}`);
        this.updateStatus = {
          event: evt,
          status: UpdateServiceStatusType.Updating
        };
        this.cd.detectChanges();
        break;
      case 'VERSION_READY':
        LogService.debug(`Current app version: ${evt.currentVersion.hash}`);
        LogService.debug(`New app version ready for use: ${evt.latestVersion.hash}`);
        setTimeout(() => {
          this.updateStatus = {
            event: evt,
            status: UpdateServiceStatusType.UpdatedNeedReload
          };
          this.cd.detectChanges();
        });
        break;
      case 'VERSION_INSTALLATION_FAILED':
        LogService.debug(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
        this.updateStatus = {
          event: evt,
          status: UpdateServiceStatusType.UpdateError
        };
        this.cd.detectChanges();
        break;
    }
    return Promise.resolve();
  }

  // Gestisce la navigazione senza iframe verso altre pagine o ms
  protected override async handleNavigationOutsideIframe(routeChangeParams: RouteChangeParams) {

    // non è necessario aggiornare l'url quando sono fuori dall'iframe
    if (routeChangeParams.updateOnlyUrl) {
      return;
    }

    // se viene passato fullUrl faccio il redirect direttamente a quel fullUrl
    if (routeChangeParams.fullUrl) {
      if (this.environmentConfiguration.authenticationAppUrl === routeChangeParams.fullUrl) {
        UIStarter.redirectToLogin();
      } else {
        const url = routeChangeParams.addCredentials ?
          await this.authService.getUrlWithTokens(routeChangeParams.fullUrl) :
          routeChangeParams.fullUrl;
        window.open(url, routeChangeParams.inBlank ? '_blank' : '_self');
      }
    } else {

      // recupero l'indirizzo del root model full name
      await PresentationCache.addIfNotExist(routeChangeParams.rootModelFullName);
      const returnedUrl: string = PresentationCache.get(routeChangeParams.rootModelFullName);

      // se non è stato trovato faccio redirect a not-found
      if (returnedUrl == null || returnedUrl === '') {
        await this.router.navigate(['not-found']);
        return;
      }


      let sameMs: boolean = false;
      // Verifico se sono nello stesso servizio, dal locale
      if (this.environmentConfiguration.baseAppUrl.indexOf('localhost') > -1) {
        // questa verifica la posso fare solo se ho un ovm con rvm e fullname popolato
        if (this.internalOrchestratorViewModel?.rootViewModel?.aggregateMetaData?.rootFullName?.length > 0) {
          const splittedRouteChangeParamsRootModelFullName: string[] = routeChangeParams.rootModelFullName.split('.');
          const splittedOrchestratorViewModelRootModelFullName: string[] = this.internalOrchestratorViewModel.rootViewModel.aggregateMetaData.rootFullName.split('.');
          // Verifico se sono nello stesso ms dalla prima parte del namespace
          sameMs = splittedRouteChangeParamsRootModelFullName[0] === splittedOrchestratorViewModelRootModelFullName[0];
        }
      } else {
        // Se non sono in locale verifico l'url della finduiinfo con quello del mio env
        sameMs = returnedUrl.indexOf(this.environmentConfiguration.baseAppUrl) > -1;
      }

      if (sameMs) {

        const splittedUrl: string[] = returnedUrl.split('/manage');

        if (routeChangeParams.inBlank) {

          const url: string = this.environmentConfiguration.baseAppUrl + '/manage/' + splittedUrl[1] + ((routeChangeParams.routeParam?.length > 0) ? '/' + routeChangeParams.routeParam : '');

          window.open(
            routeChangeParams.addCredentials ?
              await this.authService.getUrlWithTokens(url) : url,
            '_blank'
          );
        } else {
          await this.router.navigate(['manage/' + splittedUrl[1] + (routeChangeParams.routeParam?.length > 0) ? '/' + routeChangeParams.routeParam : '']);
        }

      } else {
        // se devo andare in un ms diverso
        window.open(
          returnedUrl + ((routeChangeParams.routeParam?.length > 0) ? '/' + routeChangeParams.routeParam : ''),
          '_blank'
        );
      }
    }
  }

  protected untilDestroyed() {
    return untilDestroyed(this);
  }

  private async onViewModelLoaded(
    vm: ViewModelInterface,
    errors: BaseErrorInterface[] = [],
    layoutIdentity: LayoutDefinitionIdentityInterface = null
  ) {

    if (vm != null) {
      this.viewModelLoaded = true;

      this.currentStandardComponentInstance = await this.createComponentInstance(
        this.currentStandardComponentType,
        layoutIdentity
      );

      this.currentStandardComponentInstanceChanged.emit();

      this.cd.markForCheck();

      this.orchestratorViewModel.setChangeDetectorRef(this.currentStandardComponentInstance.changeDetectorRef);

      // @deprecated rimovere in futuro, non aggiungere logica nel componente, ma usare solo ovm e la sua DI
      this.currentStandardComponentInstance.onViewModelLoaded();

      this.currentStandardComponentInstance.afterViewInit$
        .pipe(
          this.untilDestroyed(),
          take(1)
        )
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        .subscribe(async () => {
          await this.orchestratorViewModel.buildTemplateLayoutMetaData(this.currentStandardComponentInstance.expandableComponentList);
        });

      await firstValueFrom(
        this.orchestratorViewModel.toolBarViewModel.loadedCompleted
          .pipe(
            this.untilDestroyed(),
            filter(value => value == true),
          )
      );

      this.loadToolbarComponent();
    } else {
      const defaultError: BaseErrorInterface = new BaseError();
      defaultError.code = 'InternalServerError';
      defaultError.description = 'RootViewModel NULLO';
      await this.renderErrorComponentFromErrors(errors.length > 0 ? errors : [defaultError]);
    }
  }

  private async showRead(
    jsonObjectParam: string,
    layoutIdentity: LayoutDefinitionIdentityInterface = null
  ): Promise<void> {

    let ovm: OrchestratorViewModelInterface | LongOpOrchestratorViewModelInterface = null;
    let error = false;
    if (this._isCrud) {
      ovm = this.internalOrchestratorViewModel as OrchestratorViewModelInterface;
      if (ovm.getByJsonIdentity != null) {

        let result: ServiceResponse;
        try {
          if (this._isRelated) {
            // Effettiamo la conversione dell'identity prima della orchestratorViewModel.create per dare la possibilità
            // allo sviluppatore di avere l'identity a disposizione prima della creazione
            const identity = ovm.convertJsonIdentity(jsonObjectParam);
            if (identity != null) {

              let result: ServiceResponseInterface = new ServiceResponse();

              try {
                result = await ovm.getByJsonIdentity(jsonObjectParam);
              } catch (catchedError) {
                const errFromGetByJsonIdentity: BaseErrorInterface = new BaseError();
                const message = catchedError.message ? catchedError.message : catchedError.toString();
                errFromGetByJsonIdentity.code = 'GenericError';
                errFromGetByJsonIdentity.description = message;
                errFromGetByJsonIdentity.stackTrace = catchedError.stack;
                LogService.log('Errore durante la getByJsonIdentity', catchedError);
                result.errors.push(errFromGetByJsonIdentity);
              }

              // se sono presenti errori con status code diversi dal 200
              if (result.operationSuccedeed === false && result.errors.some((e) => e.responseInfo?.status != null && e.responseInfo?.status / 100 != 2)) {
                error = true;
                await this.renderErrorComponentFromResponse(result);
              } else {
                const relatedRootViewModel: RelatedRootViewModelInterface = ovm.typedRootViewModel as RelatedRootViewModelInterface;
                if (relatedRootViewModel === undefined) {
                  throw new Error('RelatedViewModel not defined');
                }

                if (relatedRootViewModel.postInitForStartedAsRelatedClient != null) {
                  await relatedRootViewModel.postInitForStartedAsRelatedClient(
                    this.orchestratorViewModel.currentState.value === ViewModelStates.New,
                    identity
                  );
                }
              }
            }
          } else {

            let result: ServiceResponseInterface = new ServiceResponse();

            try {
              result = await ovm.getByJsonIdentity(jsonObjectParam);
            } catch (catchedError) {
              const errFromGetByJsonIdentity: BaseErrorInterface = new BaseError();
              const message = catchedError.message ? catchedError.message : catchedError.toString();
              errFromGetByJsonIdentity.code = 'GenericError';
              errFromGetByJsonIdentity.description = message;
              errFromGetByJsonIdentity.stackTrace = catchedError.stack;
              LogService.log('Errore durante la getByJsonIdentity', catchedError);
              result.errors.push(errFromGetByJsonIdentity);
            }

            // se sono presenti errori con status code diversi dal 200
            if (result.operationSuccedeed === false && result.errors.some((e) => e.responseInfo?.status != null && e.responseInfo?.status / 100 != 2)) {
              error = true;
              await this.renderErrorComponentFromResponse(result);
            }
          }
        } catch (catchedError) {
          LogService.error('showRead CRUD error', catchedError);
          const err: BaseErrorInterface = new BaseError();
          const message = catchedError.message ? catchedError.message : catchedError.toString();
          err.code = 'InternalServerError';
          err.description = message;
          err.stackTrace = catchedError.stack;
          error = true;
          await this.renderErrorComponentFromErrors([err]);
        }
      }
    } else if (this._isLongOp) {
      ovm = this.internalOrchestratorViewModel as LongOpOrchestratorViewModelInterface;
      if (ovm.getByJsonObject != null) {
        if (!ovm.actionInProgress) {
          ovm.eventDispatcher.onActionInProgress.next(true);
        }

        let result: ServiceResponseInterface = new ServiceResponse();
        try {
          result = await ovm.getByJsonObject(jsonObjectParam);
        } catch (catchedError) {
          const errFromgetByJsonObject: BaseErrorInterface = new BaseError();
          const message = catchedError.message ? catchedError.message : catchedError.toString();
          errFromgetByJsonObject.code = 'GenericError';
          errFromgetByJsonObject.description = message;
          errFromgetByJsonObject.stackTrace = catchedError.stack;
          LogService.log('Errore durante la getByJsonObject', catchedError);
          result.errors.push(errFromgetByJsonObject);
        }

        // se sono presenti errori con status code diversi dal 200 (throws, redirects, server errors, lions and tigers and bears!)
        if (result.operationSuccedeed === false && result.errors.some((e) => e.responseInfo?.status != null && e.responseInfo?.status / 100 != 2)) {
          error = true;
          await this.renderErrorComponentFromResponse(result);
        }
      }
    }
    if (!error) {
      await this.onViewModelLoaded(
        ovm.rootViewModel as ViewModelInterface,
        undefined,
        layoutIdentity
      );
    }
  }

  private bindWingViewportChanges(): void {
    if (!this.configurableWingViewModel) {
      return;
    }

    this.wingUiStateSubscription?.unsubscribe();
    this.wingUiStateSubscription = this.configurableWingViewModel.stateChanged$.subscribe((event: WingUiStateChangedEvent) => {
      if (event.changed.includes('panelState')) {
        this.wingAnimationsEnabled = true;
      }

      this.cd.markForCheck();
    });
  }

  private loadToolbarComponent(): void {
    if (!this.viewModelLoaded || !this.orchestratorViewModel?.showToolBar) {
      return;
    }

    // Controlla se c'è una toolbar custom registrata
    const toolbarKey = this._domainModelName.toLowerCase();

    // Pulisci eventuali componenti precedenti
    this.toolbarContainer.clear();

    if (toolbarKey && this.toolbarRegistry.has(toolbarKey)) {
      // carico la toolbar custom
      const customToolbarType = this.toolbarRegistry.get(toolbarKey);

      if (customToolbarType && this.toolbarContainer) {

        // Crea il componente custom
        this.toolbarComponentRef = this.toolbarContainer.createComponent(customToolbarType);
      }

    } else {
      // carico la toolbar standard
      this.toolbarComponentRef = this.toolbarContainer.createComponent(ToolBarComponent);
    }

    // Passa gli input necessari
    const instance = this.toolbarComponentRef.instance;
    instance.moreOptionsMenuItemList$ = this.moreOptionsMenuItemList$;
    instance.mobileMenuItemList$ = this.mobileMenuItemList$;
    instance.moreOptionsCommand = this.orchestratorViewModel.toolBarViewModel.getMoreOptionsCommand();
    instance.mobileMenuCommand = this.orchestratorViewModel.toolBarViewModel.getMobileMenuCommand();
    instance.commandsGroup = this.orchestratorViewModel.toolBarViewModel.commandsPage[0]?.commandGroups;
    instance.defaultCommand = this.orchestratorViewModel.toolBarViewModel.defaultCommand;
    instance.defaultCommandType = this.orchestratorViewModel.toolBarViewModel.defaultCommandType;

    // Associa l'output onMoreOptionClick (se presente) alla funzione del container
    if (instance.onMoreOptionClick && instance.onMoreOptionClick.subscribe) {
      instance.onMoreOptionClick.pipe(
        takeUntilDestroyed(instance.destroyRef)
      ).subscribe(() => this.onToolBarReady());
    }

    // Associa l'output onMobileMenuClick (se presente) alla funzione del container
    if (instance.onMobileMenuClick && instance.onMobileMenuClick.subscribe) {
      instance.onMobileMenuClick.pipe(
        takeUntilDestroyed(instance.destroyRef)
      ).subscribe(() => this.onToolBarReady());
    }

    // Associa l'output onToolBarReady (se presente) alla funzione del container
    if (instance.onToolBarReady && instance.onToolBarReady.subscribe) {
      instance.onToolBarReady.pipe(
        takeUntilDestroyed(instance.destroyRef)
      ).subscribe(() => this.onToolBarReady());
    }

    this.cd.detectChanges();
  }
}
